export enum ShipmentSapUpdateStatus {
  Transferred = 'TRANSFERRED',
  Updated = 'UPDATED',
}
